import { useState } from "react";
import { API } from "aws-amplify";
import { Flex, message } from "antd";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { safeDeepClone } from "../../../utils";
import { getTranslation } from "./translations";
import { Modal, TagList } from "../../commonComponents";
import InputComponent from "../../InputComponent/InputComponent";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { programFields as programFieldsReducer } from "../../../store/actions";

const arrays = { columnDefs: "Kolonat" };
const strings = { title: "Titulli", subTitle: "Nëntitulli", note: "Shënim" };

const DEFAULT_FILTERS_FIELD_ID = "0d452d-1f23tut-4b2d6gt5-a7d8e8w6";

const ReportPersonalizer = ({ open, setOpen, constants }) => {
  const dispatch = useDispatch();
  const { reportType } = useParams();

  const { isDarkMode } = useSelector((state) => state.usersList);
  const { programFields } = useSelector((state) => state.programFields);

  const [reportData, setReportData] = useState(constants?.[reportType] || {});

  const handleKeyUpdate = (key, value) => {
    setReportData((prev) => ({ ...prev, [key]: value }));
  };

  const handleColumnRemoval = (col) => {
    setReportData((prev) => ({
      ...prev,
      columnDefs: (prev.columnDefs || []).filter((c) => c !== col.value),
    }));
  };

  const handleSave = async () => {
    try {
      const newPF = safeDeepClone(programFields);
      const idx = newPF.findIndex(
        ({ fieldId }) => fieldId === DEFAULT_FILTERS_FIELD_ID
      );
      if (idx === -1) return;

      const currFilters = newPF[idx].fieldOptions || {};
      const fieldOptions = {
        ...currFilters,
        [reportType]: {
          ...(currFilters[reportType] || {}),
          ...reportData,
        },
      };

      await API.put(
        "programFields",
        `/programFields/${DEFAULT_FILTERS_FIELD_ID}`,
        { body: { fieldOptions } }
      );
      newPF[idx] = { ...newPF[idx], fieldOptions };
      dispatch(programFieldsReducer(newPF));
      message.success("Filtrat u ruajtën me sukses");
      setOpen(false);
    } catch (e) {
      message.error("Ka ndodhur një gabim gjatë ruajtjes së filtrave");
      console.error("Error saving columns", e);
    }
  };

  //region RETURN
  return (
    <Modal
      open={open}
      style={{ height: 700 }}
      title={"Personalizo filtrat"}
      onCancel={() => setOpen(false)}
      footer={[
        <span></span>,
        <MondayButton onClick={handleSave}>
          Ruaj Filtrat kete raport
        </MondayButton>,
      ]}
    >
      <Flex vertical gap={10} style={{ width: "500px" }}>
        {Object.entries(strings).map(([key, label]) => (
          <InputComponent
            type="input"
            label={label}
            value={reportData[key] || ""}
            onChange={(e) => handleKeyUpdate(key, e.target.value)}
          />
        ))}
        {Object.entries(arrays).map(([key, label]) => (
          <InputComponent
            value={null}
            type="select"
            label={label}
            mode="multiple"
            variant={false}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              String(option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            placeholder="Zgjidh një kolonë"
            onSelect={(e) =>
              handleKeyUpdate(key, (reportData.columnDefs || []).concat(e))
            }
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            customOptions={(reportData.allAppliedColumnDefs || [])
              .filter((el) => !reportData.columnDefs.includes(el))
              .map((col) => ({
                value: col,
                label: getTranslation(col),
              }))}
          />
        ))}
        <TagList
          dndDisabled={false}
          onRemove={handleColumnRemoval}
          style={{ maxHeight: 400, overflowY: "auto" }}
          onReorder={(arr) =>
            handleKeyUpdate(
              "columnDefs",
              arr.map((el) => el.value)
            )
          }
          items={(reportData.columnDefs || []).map((el) => ({
            label: getTranslation(el),
            value: el,
          }))}
        />
      </Flex>
    </Modal>
  );
};

export default ReportPersonalizer;
